import React from 'react'
import { useHistory } from 'react-router-dom'
import SepratePart from '../../Components/SepratePart/SepratePart'
import Style from './Pages.module.css'
const Pages = () => {
    const history=useHistory()
    return (
        <div className={Style.PageHolder}>
            <SepratePart ImgSrc={"./Assets/Images/Price/list.svg"} PartName={'لیست صفحه ها'} clickhandler={()=>history.push('/pageslist')}/>
            <SepratePart ImgSrc={"./Assets/Images/Price/addtoList.svg"} PartName={'افزودن  صفحه'} clickhandler={()=>history.push('/addpage')}/>
        </div>
    )
}

export default Pages
